
export const GEN_COLORS = {
  '0': 'light-white',
  '1': 'light-success',
  '2': 'light-partial-success',
  '3': 'light-lemon',
  '4': 'light-warning',
  '5': 'light-ladrillo',
  '6': 'light-rosa',
  '7': 'light-violeta',
  '8': 'light-gris-blue',
  '9': 'light-turquesa',
  '10': 'light-darkblue',
  '11': 'light-secondary',
  '12': 'light-dark',
  '13': 'light-ladrillo',
  '14': 'light-warning',
  '15': 'light-lemon',
  '16': 'light-partial-success',
};

export const RESTYLE_COLORS = {
  '0': 'dark',
  '1': 'primary',
  '2': 'warning',
  '3': 'info',
  '4': 'rosa',
}

// Colors for a model's wildcard type (family/model/submodel). Single source of truth, shared by the
// Models manager table and by TrimSpec (when a modelId resolves to a known type via useModelsData).
// Keyed by the singular schema `type` enum (model/schemas/schemaModel.js).
export const MODEL_TYPE_COLORS = {
  family: 'violeta-dark',
  model: 'violeta',
  submodel: 'rosa',
};

// `ModelGenerationsData.modelTypeOf()` returns plural forms; normalize them to the singular keys above.
const MODEL_TYPE_ALIASES = { families: 'family', models: 'model', submodels: 'submodel' };

/** Color for a model type, accepting either the singular schema enum or the plural `modelTypeOf` form. */
export function modelTypeColor(type) {
  return MODEL_TYPE_COLORS[MODEL_TYPE_ALIASES[type] || type];
}

export const TRIM_FIELD_COLORS_MAPPING = {
  'bodyStyle': 'warning',

  'doors': 'primary',
  'engine_fuel': 'primary',

  'engine': 'gris-blue',
  'equipment': 'secondary',
  'other': 'secondary',

  'year': 'dark',
  'years': 'dark',
  'modelId': MODEL_TYPE_COLORS.model,
  'model': MODEL_TYPE_COLORS.model,
  'make': 'violeta',
  'family': MODEL_TYPE_COLORS.family,
  'submodel': MODEL_TYPE_COLORS.submodel,
  'genId': 'success',
  'country': 'darkred',

  // TODO: Used in casual user vehicle
  'trimText': 'secondary',
  'fuelType': 'gris-blue',
  'transmission': 'gris-blue',
  'countryCode': 'secondary',
  'trimId': 'light',

  '_source': 'light',
  '_inherit': 'light-danger',

  // TODO: Used in legos
  'body': 'gris-blue',
  'trims': 'turquesa',
  'trim': 'turquesa',
  'fuel': 'gris-blue',
  'ver': 'darkred'
};